export default __webpack_public_path__ + "static/media/logic.c9c676b8.jpg";